import { render, staticRenderFns } from "./services-table.vue?vue&type=template&id=0c446545"
import script from "./services-table.vue?vue&type=script&lang=ts"
export * from "./services-table.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports